import { render, staticRenderFns } from "./ListImageWithPrevLinks.vue?vue&type=template&id=2b136d67&scoped=true"
import script from "./ListImageWithPrevLinks.vue?vue&type=script&lang=js"
export * from "./ListImageWithPrevLinks.vue?vue&type=script&lang=js"
import style0 from "./ListImageWithPrevLinks.vue?vue&type=style&index=0&id=2b136d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b136d67",
  null
  
)

export default component.exports